/**
 * SHA-256 of a font file's bytes, lowercase hex: what tells the same file from a newer release
 * that claims the same name and cut.
 */
export async function fontContentHash(bytes: BufferSource): Promise<string> {
  // eslint-disable-next-line i18next/no-literal-string -- a digest algorithm name, not copy
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, '0')).join('');
}
